import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DateService} from '../../../core/services/date.service';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { SafeHtmlPipe } from '../../../pipes/safeHtml.pipe';


export interface ConfigSaisieDate {
    beforeIdentifier?: string;
    afterIdentifier?: string;
    min?: string;
    max?: string;
    label?: string;
    identifier?: string;
    value?: string | Date;
    required?: boolean;
}

@Component({
    selector: 'app-modal-confirm',
    templateUrl: './modal-saisie-date.component.html',
    styleUrls: ['./modal-saisie-date.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatButton, CdkTextareaAutosize, MatDialogActions, MatDialogClose, SafeHtmlPipe]
})
export class ModalSaisieDateComponent {
    data = inject<{
    title?: string;
    textContent?: string;
    infoDate?: string;
    helpContent?: string;
    dangerContent?: string;
    showComment?: boolean;
    titleComment?: string;
    cancel?: string;
    confirm?: string;
    value?: ConfigSaisieDate | ConfigSaisieDate[];
    shortcuts: {
        label: string;
        value: string | Date;
    }[];
    formGroupValidator: ValidatorFn;
}>(MAT_DIALOG_DATA);
    private dateService = inject(DateService);
    private matDialogRef = inject<MatDialogRef<ModalSaisieDateComponent>>(MatDialogRef);


    public form: UntypedFormGroup;

    title = 'Confirmation';
    textContent = 'Veuillez sélectionner une date pour horodater cette action :';
    titleComment = 'Commentaire';
    showComment = false;
    cancel = 'Non';
    confirm = 'Oui';

    DateService = DateService;

    dates: ConfigSaisieDate[];

    constructor() {
        const data = this.data;


        if (data.title && data.title !== '') {
            this.title = data.title;
        } else {
            this.title = 'Confirmation';
        }

        if (data.textContent && data.textContent !== '') {
            this.textContent = data.textContent;
        } else {
            this.textContent = 'Veuillez sélectionner une date pour horodater cette action :';
        }

        if (data.cancel && data.cancel !== '') {
            this.cancel = data.cancel;
        } else {
            this.cancel = 'Annuler';
        }

        if (data.showComment) {
            this.showComment = data.showComment;
            this.form.controls['comment'] = new UntypedFormControl(null, [Validators.required, Validators.minLength(1)]);
        }

        if (data.titleComment) {
            this.titleComment = data.titleComment;
        }

        if (data.confirm && data.confirm !== '') {
            this.confirm = data.confirm;
        } else {
            this.confirm = 'Confirmer';
        }

        if (data.value) {
            const dates = Array.isArray(data.value) ? data.value : [data.value];

            this.dates = dates.map(
                (value, index) => ({
                    label: 'Date',
                    ...value,
                    min: value.min ? DateService.getIsoDate(value.min) : undefined,
                    max: value.max ? DateService.getIsoDate(value.max) : undefined,
                    identifier: value.identifier ?? (dates.length === 1 ? 'date' : 'date' + index)
                })
            );
        } else {
            this.dates = [
                {
                    label: 'Date'
                }
            ];
        }

        const controls = {} as { [key: string]: AbstractControl};
        this.dates.forEach(
            (value) => {
                const validators = [];
                if (value.required || value.required === undefined) {
                    validators.push(Validators.required);
                }
                controls[value.identifier] = new UntypedFormControl(
                    value.value ? DateService.getIsoDate(value.value) : null,
                    validators
                );
            }
        );

        if(this.showComment){
            controls['comment'] = new UntypedFormControl();
        }

        this.form = new UntypedFormGroup(controls, data.formGroupValidator ?? []);
    }

    public disableValidButton() {
        if (this.showComment) {
            if (!this.form.get('comment')?.value) {
                return true;
            }
            if (this.form.get('comment')?.value?.trim()?.length <= 0) {
                return true;
            }
        }

        return !this.form.valid;
    }

    applyShortcut(date, value: string | Date) {
        this.form.get(date.identifier)?.patchValue(DateService.getIsoDate(value));
    }
}
